import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { defineRule, configure, ErrorMessage, Field, Form } from 'vee-validate';
import { required, email, max, min, regex, min_value, max_value, numeric, not_one_of } from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
import cs from '@vee-validate/i18n/dist/locale/cs.json';
import 'scriptsShared/Validators/sharedValidators.js';
import * as Sentry from "@sentry/vue";
import { CaptureConsole, Dedupe, ExtraErrorData, RewriteFrames } from "@sentry/integrations";
import { createBootstrap } from 'bootstrap-vue-next';
import { BModal } from 'bootstrap-vue-next'
import * as bootstrap from 'bootstrap';
//import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import 'regenerator-runtime/runtime.js';
import { createGtm } from "vue-gtm";
import { VueScreenSizeMixin } from 'vue-screen-size';
import axios from 'axios';
import numbro from "numbro";
import moment from 'moment';
import numbroCzechLang from "numbro/languages/cs-CZ";
import numbroSlovakLang from "numbro/languages/sk-SK";
import layout from "componentsShared/Layout/Layout.vue";
import TopNavigationMenuVue from "componentsShared/NavigationMenu/TopNavigationMenu.vue";
import IfasCard from "componentsShared/IfasCard/IfasCard.vue";
import IfasCardHeaderButton from "componentsShared/IfasCard/IfasCardHeaderButton.vue";
import ToastPlugin from 'vue-toast-notification';
import VueAxios from "vue-axios";
import $ from 'jquery';
import {createApp, toRaw} from 'vue';
import { v4 as uuidv4 } from 'uuid';
import SideModal from 'componentsShared/Modal/SideModal.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faAngleDoubleUp, faArrowCircleRight, faArrowLeft, faArrowRight,
    faBan, faCalculator, faCalendarAlt, faCaretDown, faCaretLeft,
    faCaretRight, faCaretUp, faCheck, faCheckCircle, faCheckDouble,
    faChevronDown, faChevronUp, faCircle, faCircleNotch, faClone,
    faCopy, faDownload, faEdit, faExclamation, faExclamationTriangle,
    faExternalLinkSquareAlt, faEye, faEyeSlash, faFileContract,
    faFileDownload, faFileInvoice, faFilter, faInbox, faInfoCircle,
    faLock, faLockOpen, faMinus, faMinusSquare, faMoneyBillWave,
    faPen, faPercentage, faPlus, faPlusCircle, faPlusSquare, faPrint,
    faQuestionCircle, faRobot, faSave, faSearch, faSearchLocation,
    faSnowflake, faSort, faSortAmountDownAlt, faSortAmountUpAlt,
    faSortDown, faSortUp, faSpinner,
    faSync, faSyncAlt, faTimes, faTrash, faTrashAlt, faUndo,
    faUniversity, faUsers,
} from '@fortawesome/free-solid-svg-icons';
import {
    faBookmark, faCircle as farCircle, faCircleCheck, faCircleXmark,
    faQuestionCircle as farQuestionCircle,
} from '@fortawesome/free-regular-svg-icons';

library.add(
    faAngleDoubleUp, faArrowCircleRight, faArrowLeft, faArrowRight,
    faBan, faCalculator, faCalendarAlt, faCaretDown, faCaretLeft,
    faCaretRight, faCaretUp, faCheck, faCheckCircle, faCheckDouble,
    faChevronDown, faChevronUp, faCircle, faCircleNotch, faClone,
    faCopy, faDownload, faEdit, faExclamation, faExclamationTriangle,
    faExternalLinkSquareAlt, faEye, faEyeSlash, faFileContract,
    faFileDownload, faFileInvoice, faFilter, faInbox, faInfoCircle,
    faLock, faLockOpen, faMinus, faMinusSquare, faMoneyBillWave,
    faPen, faPercentage, faPlus, faPlusCircle, faPlusSquare, faPrint,
    faQuestionCircle, faRobot, faSave, faSearch, faSearchLocation,
    faSnowflake, faSort, faSortAmountDownAlt, faSortAmountUpAlt,
    faSortDown, faSortUp, faSpinner,
    faSync, faSyncAlt, faTimes, faTrash, faTrashAlt, faUndo,
    faUniversity, faUsers,
    faBookmark, farCircle, faCircleCheck, faCircleXmark,
    farQuestionCircle,
);

// Konstanty a pomocné funkce
const notAvailable = "N/A";
const dictionary = {}; // Pokud máte vlastní definice pro localize
const rules = {
    required,
    email,
    max,
    min,
    regex,
    min_value,
    max_value,
};

const localeMessages = {
    'cs-CZ': {
        year1: '1 rok',
        years2to4: (n) => `${n} roky`,
        years5plus: (n) => `${n} let`,
        years0: (n) => `${n} let`,
        month1: '1 měs.',
        months2to4: (n) => `${n} měs.`,
        months5plus: (n) => `${n} měs.`,
        monthFull1: '1 měsíc',
        monthsFull2to4: (n) => `${n} měsíce`,
        monthsFull5plus: (n) => `${n} měsíců`,
        boolYes: 'ANO',
        boolNo: 'NE',
        boolDetailedYes: 'PRAVDA',
        boolDetailedNo: 'NEPRAVDA',
        boolYesLower: 'Ano',
        boolNoLower: 'Ne',
        propertyTypes: {
            'BytovaJednotka': 'Bytová jednotka',
            'RodinnyDum': 'Rodinný dům',
            'Pozemek': 'Pozemek',
            'Garaz': 'Garáž',
            'Ostatni': 'Ostatní',
        },
        loanPurposes: {
            'Koupit': 'Koupě',
            'Postavit': 'Výstavba',
            'Rekonstruovat': 'Rekonstrukce',
            'Refinancovat': 'Refinancování',
            'Ostatni': 'Ostatní',
        },
    },
    'sk-SK': {
        year1: '1 rok',
        years2to4: (n) => `${n} roky`,
        years5plus: (n) => `${n} rokov`,
        years0: (n) => `${n} rokov`,
        month1: '1 mes.',
        months2to4: (n) => `${n} mes.`,
        months5plus: (n) => `${n} mes.`,
        monthFull1: '1 mesiac',
        monthsFull2to4: (n) => `${n} mesiace`,
        monthsFull5plus: (n) => `${n} mesiacov`,
        boolYes: 'ÁNO',
        boolNo: 'NIE',
        boolDetailedYes: 'PRAVDA',
        boolDetailedNo: 'NEPRAVDA',
        boolYesLower: 'Áno',
        boolNoLower: 'Nie',
        propertyTypes: {
            'BytovaJednotka': 'Byt',
            'Apartment': 'Byt',
            'RodinnyDum': 'Rodinný dom',
            'House': 'Rodinný dom',
            'Pozemek': 'Stavebný pozemok',
            'Land': 'Stavebný pozemok',
            'RekreacniObjekt': 'Rekreačný objekt',
            'HolidayHome': 'Rekreačný objekt',
            'BytovyDum': 'Rozostavaná stavba',
            'ApartmentBuilding': 'Rozostavaná stavba',
            'Jiny': 'Apartmán, Nebytový priestor',
            'Other': 'Apartmán, Nebytový priestor',
            'PolyfunkcniObjekt': 'Polyfunkčný objekt',
            'MultifunctionalBuilding': 'Polyfunkčný objekt',
            'Garaz': 'Garáž',
            'Ostatni': 'Ostatné',
        },
        loanPurposes: {
            'Koupit': 'Kúpa',
            'Purchase': 'Kúpa',
            'Postavit': 'Výstavba',
            'Construction': 'Výstavba',
            'Rekonstruovat': 'Rekonštrukcia',
            'Reconstruction': 'Rekonštrukcia',
            'Refinancovat': 'Refinancovanie',
            'Refinancing': 'Refinancovanie',
            'Consolidation': 'Konsolidácia',
            'MoneyForAnything': 'Bez účelu',
            'SettlementOfInheritance': 'Vysporiadanie dedičstva / BSM',
            'Ostatni': 'Ostatné',
        },
    },
};

function getLocaleMessages(locale) {
    return localeMessages[locale] || localeMessages['cs-CZ'];
}

function formatYears(value, msgs) {
    if (value === 0) return msgs.years0(value);
    if (value === 1) return msgs.year1;
    if (value >= 2 && value <= 4) return msgs.years2to4(value);
    return msgs.years5plus(value);
}

export function InitCommonLibs(app, locale = 'cs-CZ') {
    // Google Tag Manager
    if (contextSettingsData.allowGtm) {
        app.use(
            createGtm({
                id: contextSettingsData.gtmId,
                queryParams: { gtm_cookies_win: "x" },
                enabled: true,
                debug: false,
                loadScript: true,
            })
        );
        dataLayer.push({
            userCompany: contextSettingsData.clientLegalName,
            userId: contextSettingsData.authenticatedUserId,
        });
    }

    // Application Insights
    if (contextSettingsData.allowApplicationInsights) {
        const appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: contextSettingsData.applicationInsightsInstrumentationKey,
            },
        });
        appInsights.loadAppInsights();
        appInsights.setAuthenticatedUserContext(contextSettingsData.authenticatedUserId);
        appInsights.trackPageView();
        app.config.errorHandler = (err, vm, info) => {
            appInsights.trackException({
                exception: err,
                properties: { "vue-info": info },
            });
            appInsights.flush();
            console.error(err, info);
        };
    }

    // Sentry
    if (contextSettingsData.allowSentry) {
        Sentry.init({
            app, // Vue aplikace (např. createApp(App))
            dsn: contextSettingsData.publicSentryDsnKey,
            environment: contextSettingsData.sentryEnvironment,
            integrations: [
                new CaptureConsole({ levels: ['error'] }),
                new Dedupe(),
                new ExtraErrorData(),
                new RewriteFrames(),
            ],
            attachProps: true,
            logErrors: true,
        });

        Sentry.setUser({ id: contextSettingsData.authenticatedUserId });
    }

    // Suppress _isVue/constructor warnings from Sentry Vue SDK component trace
    app.config.warnHandler = (msg, vm, trace) => {
        if (msg.includes('"_isVue"') || msg.includes('"constructor"')) return;
        console.warn(`[Vue warn]: ${msg}${trace}`);
    };

    // Bootstrap Vue
    app.use(createBootstrap());

    // Numbro inicializace a filtry
    NumbroInit(app, locale);

    // Další pomocné funkce
    DateTimeUtilsInit(app);
    TextUtilsInit(app);
    BooleanUtilsInit(app, locale);

    // Vee-validate
    localize("cs", cs);
    localize(dictionary);

    Object.keys(rules).forEach(rule => {
        defineRule(rule, rules[rule]);
    });
    defineRule('numeric', numeric);
    defineRule('excluded', not_one_of);

    configure({
        generateMessage: localize('cs', cs),
        validateOnInput: true,
        validateOnChange: true,
        validateOnBlur: true,
    });

    // Axios
    app.use(VueAxios, axios);
    app.use(ToastPlugin, { position: "bottom-right" });

    axios.defaults.headers.common["Accept"] = "application/json";
    axios.interceptors.response.use(undefined, function (error) {
        if (error.response?.status === 401) {
            app.config.globalProperties.$toast?.info("Uživatel byl odhlášen.", {
                position: "bottom-right",
                action: {
                    text: "Znovu načíst stránku",
                    onClick: () => location.reload(),
                },
            });
            return Promise.reject(error);
        } else {
            if (!error.config?.preventDefaultError) {
                app.config.globalProperties.$toast?.error("Chyba při komunikaci se serverem. Prosím opakujte akci znovu.");
            }
            return Promise.reject(error);
        }
    });

    // Globální proměnné a mixiny
    //app.config.globalProperties._ = _;
    app.config.globalProperties.$toRaw = toRaw;
    app.config.globalProperties.$uuid = {
        v4: uuidv4,
    };

    app.config.globalProperties.$bvModal = {
        show: (id) => {
            const modal = document.getElementById(id);
            if (modal) {
                // getOrCreateInstance místo new Modal — `<b-modal>` z bootstrap-vue-next
                // už má vlastní instance navázanou na element. Vytvoření další přes new Modal()
                // způsobí kolizi dvou FocusTrapů a Maximum call stack size exceeded
                // při fokusování (oba se snaží stáhnout focus do svého trapu).
                const bsModal = bootstrap.Modal.getOrCreateInstance(modal);
                bsModal.show();
            }
        }
    }

    app.mixin(VueScreenSizeMixin);
    app.mixin({
        methods: {
            moduleUrl(append) {
                const urlSegments = window.location.pathname.split("/").slice(1, 3).join("/");
                return [window.location.protocol, "//", window.location.host, "/", urlSegments, "/", append].join("");
            },
            sentryCaptureException: function (payload, options) {
                const { level = 'error', consoleLog = true, toast = true } = options || {};

                if (consoleLog) {
                    (level === 'warning' ? console.warn : console.error)(payload);
                }
                if (toast && level === 'error' && payload?.toastGenericErrorMessage !== false) {
                    app.config.globalProperties.$toast?.error("Chyba při komunikaci se serverem. Prosím opakujte akci.");
                }

                Sentry.withScope(scope => {
                    scope.setLevel(level);
                    if (payload && typeof payload === 'object') {
                        Object.entries(payload).forEach(([k, v]) => scope.setExtra(k, v));
                    }

                    const hasError = payload instanceof Error;
                    const message =
                        (payload && (payload.message || payload.name)) ||
                        'Application log';

                    if (hasError) {
                        Sentry.captureException(payload);
                    } else {
                        Sentry.captureMessage(message);
                    }
                });
            },
            originUrl(append) {
                return [window.location.origin, "/", append].join("");
            },
            gtmTrackClickUI(eventLocation, eventName, data = {}) {
                const trackObject = {
                    event: "clickUI",
                    eventLocation,
                    eventName,
                    userCompany: contextSettingsData.clientLegalName,
                    userId: contextSettingsData.authenticatedUserId,
                    gtmId: contextSettingsData.gtmId,
                    ...data,
                };
                if (this.$gtm) this.$gtm.trackEvent(trackObject);
            },
        },
    });

    // Globální komponenty
    app.component("v-layout", layout);
    app.component("v-top-navigation", TopNavigationMenuVue);
    app.component("v-ifas-card", IfasCard);
    app.component("v-ifas-card-header-button", IfasCardHeaderButton);
    app.component("ValidationObserver", Form);
    app.component("ValidationProvider", Field);
    app.component("ErrorMessage", ErrorMessage);
    app.component('font-awesome-icon', FontAwesomeIcon);
}

// Numbro nastavení a filtry
export function NumbroInit(app, locale) {
    // Assign numbro na globalProperties
    app.config.globalProperties.numbro = numbro;
    switch (locale) {
        case 'cs-CZ':
            numbro.registerLanguage(numbroCzechLang);
            break;
        case 'sk-SK':
            numbro.registerLanguage(numbroSlovakLang);
            break;
        default:
            numbro.registerLanguage(numbroCzechLang);
            break;
    }
    numbro.setLanguage(locale);

    const msgs = getLocaleMessages(locale);

    // Jedno místo pro všechny filtry
    app.config.globalProperties.$filters = {
        currency(value) {
            if (isNaN(value)) {
                console.log("not NaN", value);
                return notAvailable;
                throw "Currency is not a number.";
            }
            if (value === null) return notAvailable;
            // Základní formátování
            return numbro(value).formatCurrency({ thousandSeparated: true, spaceSeparated: true, mantissa: 0 });
        },
        yearsAndMonths(value) {
            if (isNaN(value)) throw "Years and months is not a number.";
            if (value === null) return notAvailable;
            const years = Math.floor(value / 12);
            const months = value % 12;
            const yearsLabel = formatYears(years, msgs);
            const monthsLabel = months === 1 ? msgs.month1 : (months >= 2 && months <= 4) ? msgs.months2to4(months) : msgs.months5plus(months);
            if (!years && !months) return msgs.years0(years);
            if (!years && months) return monthsLabel;
            if (years && !months) return yearsLabel;
            return `${yearsLabel} ${monthsLabel}`;
        },
        years(value) {
            if (isNaN(value)) throw "Years is not a number.";
            if (value === null) return notAvailable;
            return formatYears(value, msgs);
        },
        number(value) {
            if (isNaN(value)) throw "Number is not a number.";
            if (value === null) return notAvailable;
            return numbro(value).format({ mantissa: 2 });
        },
        money(value) {
            if (isNaN(value)) throw "Number is not a number.";
            if (value === null) return notAvailable;
            return numbro(value).formatCurrency({ thousandSeparated: true, spaceSeparated: true, mantissa: 0 });
        },
        nbsp(value) {
            if (value === null) return value;
            if (typeof value === "string") return value.replace(/ /g, "\xa0");
            return value;
        },
        moneyWithPrecision(value, currency, precision) {
            if (isNaN(value)) throw "Number is not a number.";
            if (value === null) return notAvailable;
            return numbro(value).formatCurrency({
                output: "number",
                thousandSeparated: true,
                spaceSeparated: true,
                mantissa: precision,
            });
        },
        months(value) {
            if (isNaN(value)) throw "Months is not a number.";
            if (value === null) return notAvailable;
            if (value === 1) return msgs.monthFull1;
            if (value >= 2 && value <= 4) return msgs.monthsFull2to4(value);
            return msgs.monthsFull5plus(value);
        },
        percent(value, precision = 2) {
            if (isNaN(value)) throw "Percent is not a number.";
            if (value === null) return notAvailable;
            return numbro(value).format({ output: "percent", mantissa: precision, spaceSeparated: true });
        },
        percentPerAnum(value) {
            if (isNaN(value)) throw "percentPerAnum is not a number.";
            if (value === null) return notAvailable;
            return numbro(value).format({ output: "percent", mantissa: 2, spaceSeparated: true });
        },
        percentWithPrecision(value) {
            if (value === null) return notAvailable;
            if (isNaN(value.number)) throw "percentWithPrecision is not a number.";
            if (value.number === null) return notAvailable;
            let prefix = "";
            if (value.doubleKind === "SameOrHigher") prefix = "≥";
            if (value.doubleKind === "SameOrLess") prefix = "≤";
            if (value.doubleKind === "Exact") prefix = "=";
            return `${prefix}${numbro(value.number).format({ output: "percent", mantissa: 2, spaceSeparated: true })}`;
        },
        // Nové filtry pro ColumnComparison komponentu
        percentage(rate) {
            if (rate == null) return notAvailable;
            return numbro(rate / 100).format({ output: "percent", mantissa: 2, spaceSeparated: true });
        },
        percentageWithSign(rate) {
            if (rate == null || rate === 0) return '0,00%';
            const formatted = numbro(Math.abs(rate) / 100).format({ output: "percent", mantissa: 2, spaceSeparated: true });
            return rate > 0 ? `+${formatted}` : `-${formatted}`;
        },
        ltv(ltv) {
            if (ltv == null) return notAvailable;
            return `${Math.round(ltv)}%`;
        },
        boolean(value) {
            if (value == null) return notAvailable;
            return value ? msgs.boolYes : msgs.boolNo;
        },
        booleanDetailed(value) {
            if (value == null) return notAvailable;
            return value ? msgs.boolDetailedYes : msgs.boolDetailedNo;
        },
        propertyType(propertyType) {
            return msgs.propertyTypes[propertyType] || propertyType || notAvailable;
        },
        loanPurpose(purpose) {
            return msgs.loanPurposes[purpose] || purpose || notAvailable;
        },
        yearsFromMonths(months) {
            if (isNaN(months)) throw "yearsFromMonths is not a number.";
            if (months === null) return notAvailable;
            const years = Math.floor(months / 12);
            return formatYears(years, msgs);
        },
        dti(dti) {
            if (isNaN(dti)) throw "DTI is not a number.";
            if (dti === null) return notAvailable;
            return numbro(dti).format({ mantissa: 1 });
        }
    };
}

export function DateTimeUtilsInit(app) {
    app.config.globalProperties.moment = moment;
    if (!app.config.globalProperties.$filters) {
        app.config.globalProperties.$filters = {};
    }
    app.config.globalProperties.$filters.date = value => {
        if (value === null) return notAvailable;
        return moment(value).format("DD.MM.YYYY");
    };
    app.config.globalProperties.$filters.datetime = value => {
        if (value === null) return notAvailable;
        return moment(value).format("DD.MM.YYYY HH:mm:ss");
    };
    app.config.globalProperties.$filters.dateTimeWithoutSeconds = value => {
        if (value === null) return notAvailable;
        return moment(value).format("DD.MM.YYYY HH:mm");
    };
}

export function TextUtilsInit(app) {
    if (!app.config.globalProperties.$filters) {
        app.config.globalProperties.$filters = {};
    }
    app.config.globalProperties.$filters.textSnippet = (value, textLength) => {
        return value.length > textLength ? value.substring(0, textLength - 3) + "..." : value;
    };
    app.config.globalProperties.$filters.valueOrNA = value => {
        return value ? value : notAvailable;
    };
}

export function BooleanUtilsInit(app, locale) {
    if (!app.config.globalProperties.$filters) {
        app.config.globalProperties.$filters = {};
    }
    const msgs = getLocaleMessages(locale);
    app.config.globalProperties.$filters.bool = value => {
        if (value === null) return notAvailable;
        return value.toLowerCase() === "true" ? msgs.boolYesLower : msgs.boolNoLower;
    };
}

export function InitGlobalSideModal(app, initialData) {
    document.addEventListener('DOMContentLoaded', () => {
        const sideModalRoot = document.getElementById('sideModalRoot');
        if (sideModalRoot && initialData) {
            const sideModalApp = createApp(SideModal, { initialData });
            sideModalApp.use(createBootstrap());
            sideModalApp.config.globalProperties.axios = app.config.globalProperties.axios;
            sideModalApp.mount(sideModalRoot);
        } else {
            console.warn('⚠️ SideModal root or data not found');
        }
    });
}

